// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
}

.video-container {
  width: 100%;
  max-width: 800px; /* Make the video smaller */
  margin-bottom: 40px;
  opacity: 0.2;
  transition: opacity 0.5s ease-in-out;
  text-align: left; /* Center the title and company */
}

.video-container.appear {
  opacity: 1;
}


.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* Maintain aspect ratio */
}

.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  object-fit: cover; /* Ensure video doesn't stretch */
}

/* Thumbnail styling to match the video size */
.video-thumbnail {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensure the thumbnail doesn't stretch */
  cursor: pointer; /* Indicate clickable thumbnail */
}

@media (max-width: 768px) {
  .video-wrapper {
    padding-bottom: 75%; /* Adjust aspect ratio for smaller screens */
  }

  .video-title {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Video.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,2BAA2B;EAC7C,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,yCAAyC;EAC5D,eAAe,EAAE,iCAAiC;AACpD;;AAEA;EACE;IACE,mBAAmB,EAAE,4CAA4C;EACnE;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".video-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  padding: 20px;\n}\n\n.video-container {\n  width: 100%;\n  max-width: 800px; /* Make the video smaller */\n  margin-bottom: 40px;\n  opacity: 0.2;\n  transition: opacity 0.5s ease-in-out;\n  text-align: left; /* Center the title and company */\n}\n\n.video-container.appear {\n  opacity: 1;\n}\n\n\n.video-wrapper {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%; /* Maintain aspect ratio */\n}\n\n.video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  object-fit: cover; /* Ensure video doesn't stretch */\n}\n\n/* Thumbnail styling to match the video size */\n.video-thumbnail {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* Ensure the thumbnail doesn't stretch */\n  cursor: pointer; /* Indicate clickable thumbnail */\n}\n\n@media (max-width: 768px) {\n  .video-wrapper {\n    padding-bottom: 75%; /* Adjust aspect ratio for smaller screens */\n  }\n\n  .video-title {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
